/* eslint-disable no-console */
import { Component, Inject, Input, PLATFORM_ID } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ReferenceConst } from "@core-constants/reference.const";
import { DomainsManager } from "@core-managers/domains.manager";
import { ToastService } from "@shared-services/toast.service";
import { TranslateService } from "@shared-services/translate.service";
import { RedeemManager } from "@core-managers/redeem.manager";

@Component({
  selector: 'app-initiatives-domain',
  templateUrl: './initiatives-domain.component.html',
  styleUrls: ['./initiatives-domain.component.css']
})
export class InitiativesDomainComponent
{
  public urlNicMexicoHEM: string = ReferenceConst.NICMexicoHem;
  public textNoDomain: string = 'Estos beneficios están disponibles desde <span class="fw-bold">AKKY</span> para quienes participan en el programa <span class="fw-bold">Inc MTY</span>.';
  @Input({ required: true }) public domain!: string;
  @Input({ required: true }) public showDomainInfo: boolean = true;

  constructor(@Inject(PLATFORM_ID) private platformId,
    protected translateService: TranslateService,
    private domainsManager: DomainsManager,
    protected redeemManager: RedeemManager,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public toast: ToastService) { }

  public onSingleSearch(): void
  {
    this.domainsManager.searchSimpleDomainMx();
  }

  public onSearchChangeMode(): void
  {
    return;
  }

  public onSearchAgain() : void
  {
    this.redeemManager.removeDomain();

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        domain: null
      },
      queryParamsHandling: 'merge' 
    });
  }

  public get hasDomain(): boolean
  {
    return !!this.domain && this.domain.trim().length > 0;
  }
}
